import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { LegalService, LegalDocument } from '../../services/legal.service';
import { MetaTagService } from '../../services/meta-tag.service';

@Component({
    selector: 'app-privacy',
    templateUrl: './privacy.component.html',
    styleUrls: ['./privacy.component.scss'],
    standalone: false
})
export class PrivacyComponent implements OnInit {

  doc: LegalDocument | null = null;
  safeContent: SafeHtml | null = null;
  loading = true;
  error = false;

  constructor(
    private legalService: LegalService,
    private sanitizer: DomSanitizer,
    private seo: MetaTagService
  ) {}

  ngOnInit(): void {
    this.seo.update({
      title:       'מדיניות פרטיות',
      description: `קראו את מדיניות הפרטיות של ${this.seo.siteName} — כיצד אנו אוספים, משתמשים ומגינים על המידע שלכם.`,
      keywords:    `מדיניות פרטיות, ${this.seo.siteName}, הגנת פרטיות, מידע אישי`,
      url:         this.seo.pageUrl('/privacy'),
      noindex:     false,
      jsonLd: {
        '@context': 'https://schema.org',
        '@type':    'WebPage',
        'name':     `מדיניות פרטיות — ${this.seo.siteName}`,
        'url':      this.seo.pageUrl('/privacy'),
      }
    });
    this.legalService.getPrivacyPolicy().subscribe({
      next: (data) => {
        this.doc = data;
        this.safeContent = this.sanitizer.bypassSecurityTrustHtml(data.content || '');
        this.loading = false;
      },
      error: () => {
        this.error = true;
        this.loading = false;
      }
    });
  }
}
